import React from 'react';
import { Volume2 } from 'lucide-react';
import { getWordTextByPreference } from '../utils/chineseCharacterUtils';

const VocabularyCard = ({ 
  word, 
  languageDisplay = "traditional_to_english", 
  chineseCharacterPreference = "traditional",
  index = 0,
  showImage = true,
  showPhonetics = true,
  onClick,
  onPronunciation,
  className = ""
}) => {
  // All cards now have consistent background color
  const bgColor = "bg-yellow-100";
  
  // Get display text using the utility function
  const displayText = getWordTextByPreference(word, languageDisplay, chineseCharacterPreference);

  const handlePronunciationClick = (e) => {
    e.stopPropagation();
    if (onPronunciation) {
      onPronunciation(word);
    }
  };

  return (
    <div 
      className={`vocab-card ${bgColor} rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        {/* Left side - Primary text */}
        <div className="flex-1">
          <div className="text-lg font-semibold text-gray-800 mb-1">
            {displayText.primary}
          </div>
        </div>

        {/* Middle - Image */}
        {showImage && word.imageUrl && (
          <div className="mx-4 flex-shrink-0">
            <img 
              src={word.imageUrl} 
              alt={displayText.primary}
              className="w-12 h-12 rounded-lg object-cover shadow-sm"
              loading="lazy"
            />
          </div>
        )}

        {/* Right side - Secondary text and phonetic */}
        <div className="flex-1 text-right">
          <div className="text-lg font-semibold text-blue-600 mb-1">
            {displayText.secondary}
          </div>
          {showPhonetics && displayText.phonetic && (
            <div className="text-sm text-gray-500 font-mono">
              {String(displayText.phonetic)}
            </div>
          )}
          {word.frequency && (
            <div className="text-xs text-orange-600 mt-1">
              {word.frequency}
            </div>
          )}
        </div>

        {/* Audio button */}
        <div className="ml-2 flex-shrink-0">
          <button 
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
            onClick={handlePronunciationClick}
          >
            <Volume2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VocabularyCard;
